/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportInfo
 */
export interface SupportInfo {
    /**
     * Cell email for support. Usually it is notification email of cell operator service provider
     * @type {string}
     * @memberof SupportInfo
     */
    email?: string;
}

/**
 * Check if a given object implements the SupportInfo interface.
 */
export function instanceOfSupportInfo(value: object): boolean {
    return true;
}

export function SupportInfoFromJSON(json: any): SupportInfo {
    return SupportInfoFromJSONTyped(json, false);
}

export function SupportInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function SupportInfoToJSON(value?: SupportInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

